import { ChangeDetectorRef, Component, EventEmitter, Inject, NgZone, OnInit, Output } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { FormControl } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoadingDialogComponent } from 'src/app/loading-dialog/loading-dialog.component';


@Component({
  selector: 'app-subjects-table',
  templateUrl: './subjects-table.component.html',
  styleUrls: ['./subjects-table.component.scss']
})
export class SubjectsTableComponent implements OnInit {
  @Output() onNextTab: EventEmitter<any> = new EventEmitter<any>();
  @Output() onOffer: EventEmitter<any> = new EventEmitter<any>();
  years;
  yearsQuery;
  selectedSubjects = [];
  totalESPB = 0;
  modulsFormControl = new FormControl("informacioni-sistemi-i-tehnologije");
  queryFormControl = new FormControl("");
  moduls = [{
    name:"Menadžment Akreditacija 2014",
    id:"menadzment"
  },{
    name:"Menadžment Akreditacija 2009",
    id:"menadzment-2009"
  },{
    name:"Operacioni menadžment 2014",
    id:"operacioni-menadzment"
  },{
    name:"Operacioni menadžment 2009",
    id:"operacioni-menadzment-2009"
  },{
    name:"Menadžment kvaliteta i standardizacija 2014",
    id:"menadzment-kvaliteta-i-standardizacija"
  },{
    name:"Menadžment kvaliteta i standardizacija 2009",
    id:"upravljanje-kvalitetom"
  },{
    name:"Informacioni sistemi i tehnologije 2014",
    id:"informacioni-sistemi-i-tehnologije"
  },{
    name:"Informacioni sistemi i tehnologije 2009",
    id:"informacioni-sistemi-i-tehnologije-2009"
  }]

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private changeDetectorRef:ChangeDetectorRef,
    private ngZone:NgZone,
    private fsFunc: AngularFireFunctions,
    private dialog: MatDialog
  ) {
    data.subjects.forEach(s => s.selected = false)
    this.years = this.groupSubjectsByYear(data.subjects);
    this.yearsQuery = this.years;
    this.onModulChange("informacioni-sistemi-i-tehnologije");
  }
  ngOnInit(): void {
  }
  selectSubject(subject) {
    const indexOfSubject = this.selectedSubjects.indexOf(subject);
    if (indexOfSubject == -1) this.selectedSubjects.push(subject)
    else this.selectedSubjects.splice(indexOfSubject, 1);
    
    this.calculateTotal();
  }
  onSearchChange(searchValue: string): void {
    this.yearsQuery = this.years.map(y => {
      return y.filter(s => s.subjectNameFON.toLowerCase().indexOf(searchValue.toLowerCase()) > -1 && s.modul == this.modulsFormControl.value)
    })
    this.yearsQuery.forEach(y => {
      y.forEach(s => {
        const isSelected = this.selectedSubjects.map(ss => ss.subjectNameFON).indexOf(s.subjectNameFON) > -1 && this.selectedSubjects.map(ss => ss.modul).indexOf(this.modulsFormControl.value);
        s.selected = isSelected;
      })
    })
  }
  groupSubjectsByYear(subjects) {
    var groupedSubjects = [];
    subjects.forEach((s) => {
      if (groupedSubjects[s.year - 1] === undefined) groupedSubjects[s.year - 1] = [];
      groupedSubjects[s.year - 1].push(s);
    })
    return groupedSubjects;
  }
  calculateTotal() {
    this.totalESPB = 0;
    this.selectedSubjects.forEach(s => {
      this.totalESPB += parseInt(s.espb);
    })
  }
  sendSubjects() {
    
    const loadingDialogRef = this.dialog.open(LoadingDialogComponent,{
      disableClose:true,
    });
    this.fsFunc.httpsCallable('order-makeNewSchoolYearOffer')({
      selectedSubjects: this.selectedSubjects
    }).subscribe((response) => {
      this.ngZone.run(()=>{
        loadingDialogRef.close();
        this.onOffer.emit(response);
        this.onNextTab.emit(2);
      })
    })
  }
  onModulChange(modulID){
    this.selectedSubjects = [];
    this.yearsQuery = this.years.map(y => {
      return y.filter(s => s.modul == modulID && s.subjectNameFON.toLowerCase().indexOf(this.queryFormControl.value.toLowerCase()) > -1)
    })
    this.yearsQuery.forEach(y => {
      y.forEach(s => {
        const isSelected = this.selectedSubjects.map(ss => ss.subjectNameFON).indexOf(s.subjectNameFON) > -1 && this.selectedSubjects.map(ss => ss.modul).indexOf(modulID);
        s.selected = isSelected;
      })
    })
    
  }
}
